import toastModule from './store/module'
import { MODULE_NAME as TOAST_MODULE_NAME } from './store/types'

export const domainConfig = () => {
  return {
    vuex: [
      {
        name: TOAST_MODULE_NAME,
        moduleFactory: toastModule
      }
    ]
  }
}
